import { render } from "./ProjectsFeatured.vue?vue&type=template&id=0ff739fb"
import script from "./ProjectsFeatured.vue?vue&type=script&lang=js"
export * from "./ProjectsFeatured.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__